export function getProductV3CaptchaKey(business?: string): string {
  if (typeof window === 'undefined') {
    return;
  }

  if (
    window.location.host.includes('aprovatotal') ||
    window.location.host.includes('resolveenem') ||
    window.location.host.includes('aprovauniversitario') ||
    business === 'aprovatotal'
  ) {
    return process.env.RECAPTCHA_V3_KEY_FRONT_APROVATOTAL;
  }

  if (
    window.location.host.includes('meusucesso') ||
    business === 'meusucesso'
  ) {
    return process.env.RECAPTCHA_V3_KEY_FRONT_MS;
  }

  if (window.location.host.includes('medcof') || business === 'medcof') {
    return process.env.RECAPTCHA_V3_KEY_FRONT_MEDCOF;
  }

  if (window.location.host.includes('eumilitar') || business === 'eumilitar') {
    return process.env.RECAPTCHA_V3_KEY_FRONT_EUMILITAR;
  }

  if (
    window.location.host.includes('escolaconquer') ||
    business === 'conquer-business-school' ||
    business === 'conquer-incompany' ||
    business === 'conquer-edtech' ||
    business === 'conquer-unna' ||
    business === 'conquer-franquias'
  ) {
    return process.env.RECAPTCHA_V3_KEY_FRONT_CONQUERESCOLA;
  }

  if (window.location.host.includes('atrin.ca') || business === 'atrinca') {
    return process.env.RECAPTCHA_V3_KEY_FRONT_ATRINCA;
  }

  if (
    window.location.host.includes('mlsociety.co') ||
    business === 'mls' ||
    business === 'mentoring-league-society' ||
    business === 'mlsociety'
  ) {
    return process.env.RECAPTCHA_V3_KEY_FRONT_MLSOCIETY;
  }

  if (
    window.location.host.includes('institutodestiny') ||
    business === 'instituto-destiny'
  ) {
    return process.env.RECAPTCHA_V3_KEY_FRONT_INSTITUTO_DESTINY;
  }

  return process.env.RECAPTCHA_V3_KEY_FRONT;
}

export function getProductV2CaptchaKey(business?: string): string {
  if (typeof window === 'undefined') {
    return;
  }

  if (
    window.location.host.includes('aprovatotal') ||
    window.location.host.includes('resolveenem') ||
    window.location.host.includes('aprovauniversitario') ||
    business === 'aprovatotal'
  ) {
    return process.env.RECAPTCHA_V2_KEY_FRONT_APROVATOTAL;
  }

  if (
    window.location.host.includes('meusucesso') ||
    business === 'meusucesso'
  ) {
    return process.env.RECAPTCHA_V2_KEY_FRONT_MS;
  }

  if (window.location.host.includes('medcof') || business === 'medcof') {
    return process.env.RECAPTCHA_V2_KEY_FRONT_MEDCOF;
  }

  if (window.location.host.includes('eumilitar') || business === 'eumilitar') {
    return process.env.RECAPTCHA_V2_KEY_FRONT_EUMILITAR;
  }

  if (
    window.location.host.includes('escolaconquer') ||
    business === 'conquer-business-school' ||
    business === 'conquer-incompany' ||
    business === 'conquer-edtech' ||
    business === 'conquer-unna' ||
    business === 'conquer-franquias'
  ) {
    return process.env.RECAPTCHA_V2_KEY_FRONT_CONQUERESCOLA;
  }

  if (window.location.host.includes('atrin.ca') || business === 'atrinca') {
    return process.env.RECAPTCHA_V2_KEY_FRONT_ATRINCA;
  }

  if (
    window.location.host.includes('mlsociety.co') ||
    business === 'mls' ||
    business === 'mentoring-league-society' ||
    business === 'mlsociety'
  ) {
    return process.env.RECAPTCHA_V2_KEY_FRONT_MLSOCIETY;
  }

  if (
    window.location.host.includes('institutodestiny') ||
    business === 'instituto-destiny'
  ) {
    return process.env.RECAPTCHA_V2_KEY_FRONT_INSTITUTO_DESTINY;
  }

  return process.env.RECAPTCHA_V2_KEY_FRONT;
}
